(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.mpHeroInitialized === 'true') {
      return;
    }

    root.dataset.mpHeroInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mp-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mp-hero-dot]'));
    var prevButton = root.querySelector('[data-mp-hero-prev]');
    var nextButton = root.querySelector('[data-mp-hero-next]');
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var currentIndex = 0;
    var autoplayTimer = null;

    var touchStartX = 0;
    var touchStartY = 0;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var isPointerDown = false;
    var recentSwipe = false;

    if (slides.length <= 1) {
      return;
    }

    function setActiveSlide(index) {
      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === currentIndex;

        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === currentIndex;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function goNext() {
      setActiveSlide(currentIndex + 1);
    }

    function goPrev() {
      setActiveSlide(currentIndex - 1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (!autoplayEnabled) {
        return;
      }

      autoplayTimer = window.setInterval(goNext, autoplaySpeed);
    }

    function markRecentSwipe() {
      recentSwipe = true;

      window.setTimeout(function () {
        recentSwipe = false;
      }, 450);
    }

    function handleSwipe(startX, startY, endX, endY) {
      var diffX = endX - startX;
      var diffY = endY - startY;
      var minSwipeDistance = 50;

      if (Math.abs(diffX) < minSwipeDistance) {
        return false;
      }

      if (Math.abs(diffX) < Math.abs(diffY)) {
        return false;
      }

      stopAutoplay();

      if (diffX > 0) {
        goPrev();
      } else {
        goNext();
      }

      startAutoplay();
      markRecentSwipe();

      return true;
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        stopAutoplay();
        goPrev();
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        stopAutoplay();
        goNext();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-slide-index'), 10);

        if (Number.isNaN(index)) {
          return;
        }

        stopAutoplay();
        setActiveSlide(index);
        startAutoplay();
      });
    });

    root.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) {
        return;
      }

      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) {
        return;
      }

      var touchEndX = event.changedTouches[0].clientX;
      var touchEndY = event.changedTouches[0].clientY;
      var didSwipe = handleSwipe(touchStartX, touchStartY, touchEndX, touchEndY);

      if (didSwipe) {
        event.preventDefault();
      }
    }, { passive: false });

    root.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') {
        return;
      }

      if (event.button !== 0) {
        return;
      }

      if (event.target.closest('button')) {
        return;
      }

      isPointerDown = true;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    });

    root.addEventListener('pointerup', function (event) {
      if (!isPointerDown) {
        return;
      }

      isPointerDown = false;

      if (event.pointerType === 'touch') {
        return;
      }

      handleSwipe(pointerStartX, pointerStartY, event.clientX, event.clientY);
    });

    root.addEventListener('pointercancel', function () {
      isPointerDown = false;
    });

    root.addEventListener('click', function (event) {
      if (!recentSwipe) {
        return;
      }

      if (event.target.closest('.mp-home-hero__banner-link')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    setActiveSlide(0);
    startAutoplay();
  }

  function initAllHeroes(container) {
    var scope = container || document;
    var heroes = scope.querySelectorAll('[data-mp-home-hero]');

    heroes.forEach(function (hero) {
      initHero(hero);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllHeroes(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllHeroes(event.target);
  });
})();